var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flowy"},[_c('div',{attrs:{"id":"flowy-tree"}},_vm._l((_vm.parentNodes),function(node){return _c('FlowyNode',_vm._g(_vm._b({key:node.id,attrs:{"node":node,"before-move":_vm.onBeforeMove,"before-add":_vm.onBeforeAdd}},'FlowyNode',{ ..._vm.$props },false),{ ..._vm.$listeners }))}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }